import { useEffect, useState } from 'react';
import { Modal } from '../../../theme/Component/Modal';
import { AccountantTree } from './AccountantTree';
import useDataBean from '../../../../core/services/dataBean/useDataBean';
import { _AccountantID, _single } from '../../../../core/services/dataBean/EntityCatalog';


interface Props {
    onChange: any;
    value?: any;
    jsonCode?: string;
    idlnAccountant?: number;
    idAccountant?: number;
    label?: string;
    disabled?: boolean;
    render?: string;
}
export const SelectAccountantTree = ({ idAccountant, value, idlnAccountant, onChange, label, jsonCode, render, disabled }: Props) => {

    const { instance } = useDataBean(_AccountantID)

    const [modal, setModal] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [valor, setValor] = useState(value ?? '');

    useEffect(() => {
        if (idlnAccountant) {
            getBudgetIDLn()
        }
    }, [idlnAccountant])

    const getBudgetIDLn = () => {

        instance.getAccountantIDByKey(idlnAccountant).then(
            (resp) => {
                setValor(`${resp.JsonCode ?? ""} - ${resp.Name ?? ""}`)
                onChange(resp)
            }
        ).catch(
            err => {
                console.error(err)
            }
        )
    }

    useEffect(() => {
        if (idAccountant) {
            getBudgetId()
        }
    }, [idAccountant])

    const getBudgetId = () => {
        instance.getAccountantID(idAccountant).then(
            (resp) => {
                setValor(`${resp.JsonCode ?? ""} - ${resp.Name ?? ""}`)
                onChange(resp)
            }
        ).catch(
            err => {
                console.error(err)
            }
        )
    }

    useEffect(() => {
        if (jsonCode) {
            getBudgetJson()
        }
    }, [jsonCode])


    const getBudgetJson = () => {
        instance.getAccountantIDByCode(jsonCode).then(
            (resp) => {
                setValor(`${resp.JsonCode ?? ""} - ${resp.Name ?? ""}`)
                onChange(resp)
            }
        ).catch(
            err => {
                console.error(err)
            }
        )
    }

    const getItem = () => {
        let bean: any = JSON.parse(localStorage.getItem('accountantTree') || '{}');
        onChange(bean);
        setValor(bean.JsonCode + " - " + bean.Name);
        setModal({ ...modal, "view": false });
    }

    return (
        <>
            {label != '' && <label>{label}</label>}
            <div
                className={`form-control text-wrap ${disabled ? 'bg-light text-muted' : 'cursor-pointer'}`}
                style={{
                    minHeight: '35px',
                    opacity: disabled ? 0.6 : 1,
                    cursor: disabled ? 'not-allowed' : 'pointer'
                }}
                onClick={() => {
                    if (!disabled) {
                        setModal({ ...modal, view: true });
                    }
                }}
            >
                {render ? (
                    <span>{render}</span>
                ) : valor ? (
                    <span>{valor}</span>
                ) : (
                    <span>Seleccionar...</span>
                )}
            </div>

            <Modal onSubmitLabel='Seleccionar' modal={modal} updateModal={setModal} eventModal={getItem}>
                <AccountantTree edit={false} id={null} />
            </Modal>

        </>
    )
}